import { api } from './api';
import {
  CreateSupportGroupRequest,
  CreateSupportGroupRoutingRuleRequest,
  SupportGroup,
  SupportGroupRoutingRule,
  SupportGroupStats,
  UpdateSupportGroupMembersRequest,
  UpdateSupportGroupRequest,
  UpdateSupportGroupRoutingRuleRequest,
} from '../types/supportGroup';

class SupportGroupService {
  async getAll(): Promise<SupportGroup[]> {
    const response = await api.get<SupportGroup[]>('/support-groups');
    return response.data;
  }

  async getStats(): Promise<SupportGroupStats[]> {
    const response = await api.get<SupportGroupStats[]>('/support-groups/stats');
    return response.data;
  }

  async getById(id: string): Promise<SupportGroup> {
    const response = await api.get<SupportGroup>(`/support-groups/${id}`);
    return response.data;
  }

  async create(data: CreateSupportGroupRequest): Promise<SupportGroup> {
    const response = await api.post<SupportGroup>('/support-groups', data);
    return response.data;
  }

  async update(id: string, data: UpdateSupportGroupRequest): Promise<SupportGroup> {
    const response = await api.put<SupportGroup>(`/support-groups/${id}`, data);
    return response.data;
  }

  async delete(id: string): Promise<void> {
    await api.delete(`/support-groups/${id}`);
  }

  async updateMembers(id: string, data: UpdateSupportGroupMembersRequest): Promise<SupportGroup> {
    const response = await api.put<SupportGroup>(`/support-groups/${id}/members`, data);
    return response.data;
  }

  async createRoutingRule(
    groupId: string,
    data: CreateSupportGroupRoutingRuleRequest,
  ): Promise<SupportGroupRoutingRule> {
    const response = await api.post<SupportGroupRoutingRule>(
      `/support-groups/${groupId}/routing-rules`,
      data,
    );
    return response.data;
  }

  async updateRoutingRule(
    ruleId: string,
    data: UpdateSupportGroupRoutingRuleRequest,
  ): Promise<SupportGroupRoutingRule> {
    const response = await api.put<SupportGroupRoutingRule>(
      `/support-groups/routing-rules/${ruleId}`,
      data,
    );
    return response.data;
  }

  async deleteRoutingRule(ruleId: string): Promise<void> {
    await api.delete(`/support-groups/routing-rules/${ruleId}`);
  }
}

export const supportGroupService = new SupportGroupService();
